// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.85.0-beta.f035cc08',
  revision: 'f035cc08',
  branch: 'develop',
  date: 'Mon, 09 Feb 2026 20:47:41 GMT'
};